import * as stakingFunctions from "./functions/stakingFunctions";
import * as utilFunctions from "./functions/utilFunctions";
import * as statFunctions from "./functions/statFunctions";

export const contractFunctions = {
  ...stakingFunctions,
  ...utilFunctions,
  ...statFunctions,
};
